export enum DocumentLocation {
    Box,
    Order,
    Unknown
}